import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../ui-components/shared.module';
import { AppConfigService } from '../../@services/front/app-config.service';

/**
 * « Mise à jour nécessaire » (ARC-16) : plein écran, sans croix, quand la coque
 * installée est sous le build minimal de `/app-config`. Toujours une issue : le
 * magasin, ou la même app dans le navigateur. Avant lui, un ancien binaire
 * disait « mets à jour » sans bouton ni lien (écran 154).
 */
@Component({
  selector: 'vw-app-update-screen',
  imports: [SharedModule, TranslatePipe],
  templateUrl: './app-update-screen.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateScreenComponent {
  readonly appConfig = inject(AppConfigService);
}
